import { REPORTES, type ClaveReporte, type Permiso } from '@barbones/shared';
import { FileBarChart2, type LucideIcon } from 'lucide-react';
import { MODULOS, tieneAlguno } from './navegacion';
import { SECCIONES_POR_MODULO } from './secciones';

/** Pantalla a la que se puede saltar desde el buscador global (Ctrl K). */
export interface DestinoBuscador {
  id: string;
  etiqueta: string;
  palabrasClave?: string;
  icono: LucideIcon;
  to: string;
  search?: Record<string, string>;
}

/**
 * Módulos, todas sus secciones (incluida la primera, que comparte ruta con el módulo)
 * y cada reporte que el usuario puede consultar.
 */
export function destinosDelBuscador(permisos: readonly Permiso[]): DestinoBuscador[] {
  const pantallas = MODULOS.filter((m) => tieneAlguno(permisos, m.permisos)).flatMap((m) => [
    { id: `nav-${m.id}`, etiqueta: m.etiqueta, icono: m.icono, to: m.to },
    ...(SECCIONES_POR_MODULO[m.id] ?? [])
      .filter((s) => tieneAlguno(permisos, s.permisos))
      .map((s) => ({ id: `nav-${s.to}`, etiqueta: `${m.etiqueta} › ${s.etiqueta}`, palabrasClave: s.palabrasClave, icono: s.icono, to: s.to })),
  ]);

  const reportes = (Object.keys(REPORTES) as ClaveReporte[])
    .filter((clave) => tieneAlguno(permisos, REPORTES[clave].permisos as readonly Permiso[]))
    .map((clave) => ({
      id: `reporte-${clave}`,
      etiqueta: `Reportes › ${REPORTES[clave].titulo}`,
      palabrasClave: `reporte ${REPORTES[clave].grupo} ${REPORTES[clave].descripcion}`,
      icono: FileBarChart2,
      to: '/reportes',
      search: { r: clave },
    }));

  return [...pantallas, ...reportes];
}
